// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LsmxKW7C9k7xLH0G9m3p {
  max-height: 160px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f9f9f9;
}

.LsmxKW7C9k7xLH0G9m3p::-webkit-scrollbar {
  width: 6px;
}

.LsmxKW7C9k7xLH0G9m3p::-webkit-scrollbar-track {
  background: #f9f9f9;
  border-radius: 3px;
}

.LsmxKW7C9k7xLH0G9m3p::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.2s ease;
}

.LsmxKW7C9k7xLH0G9m3p::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
} `, "",{"version":3,"sources":["webpack://./src/components/CustomFields/SelectFieldOptions.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".optionsList {\n  max-height: 160px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f9f9f9;\n}\n\n.optionsList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.optionsList::-webkit-scrollbar-track {\n  background: #f9f9f9;\n  border-radius: 3px;\n}\n\n.optionsList::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n  transition: background 0.2s ease;\n}\n\n.optionsList::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionsList": `LsmxKW7C9k7xLH0G9m3p`
};
export default ___CSS_LOADER_EXPORT___;
